export const calcBoardParamFromDiagonal = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcBoardParamFromDiagonal', params);
        },
    };
};
